import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount)
}

/**
 * Abbreviated currency for space-constrained summaries — `$4.2M`, `$540K`.
 *
 * For aggregate figures only, where the magnitude is the point and the exact
 * cents are not. Anything a user might reconcile against should use
 * `formatCurrency`; pair this with a `title` carrying the full amount.
 */
export function formatCompactCurrency(amount: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    notation: 'compact',
    // Set explicitly: Node and the browser disagree on the currency default
    // in compact notation ($150.0K vs $150K), which failed hydration (GLASS-505).
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
  }).format(amount)
}
